import { Link, Stack } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { styles } from '../../style/style';


export default function AdminDropDown() {
    const intl = useIntl();


    const options = [
        { label: intl.formatMessage({ id: "admindropdown.tablemaintenance", defaultMessage: "BAC to FAN Table Maintenace" }), value: intl.formatMessage({ id: "admindropdown.tablemaintenance", defaultMessage: "BAC to FAN Table Maintenace" }) },
        { label: intl.formatMessage({ id: "admindropdown.messagetable", defaultMessage: "News Messages Table" }), value: intl.formatMessage({ id: "admindropdown.messagetable", defaultMessage: "News Messages Table" }) },
        { label: intl.formatMessage({ id: "mainnavbar.administration", defaultMessage: "ADMINISTRATION" }), value: intl.formatMessage({ id: "mainnavbar.administration", defaultMessage: "ADMINISTRATION" }) }
    ];


    return (
        <Stack direction='row'>
            <FormControl sx={{ minWidth: 180, minHeight: 50 }}>
                <Select
                    sx={styles.selectSx}
                    labelId="searchTypesLabel"
                    id="searchTypesLabel"
                    //value={options[0].value}
                    displayEmpty
                    name="searchTypes"
                    //textAlign="center"
                    MenuProps={{ disableScrollLock: true }}


                >
                    <Link color='inherit' href="/maintenancetable" underline="none" sx={styles.linkSX}>
                        <MenuItem id="bacToFanTableMaintOption" role={"section"} value={options[0].value} sx={styles.menuItemSx}>{options[0].label}</MenuItem>
                    </Link>
                    <Link color='inherit' href="/newstable" underline="none" sx={styles.linkSX}>
                        <MenuItem id="newMessageTableOption" role={"section"} value={options[1].value} sx={styles.menuItemSx}>{options[1].label}</MenuItem>
                    </Link>
                    <MenuItem id="3" style={{ display: "none" }}>
                        <FormattedMessage id='mainnavbar.administration' defaultMessage='ADMINISTRATION' />
                    </MenuItem>
                </Select>
            </FormControl>
        </Stack>
    );
}